import { NgModule } from '@angular/core';

//PrimeNG 11.4.7 LTS
import { AccordionModule } from 'primeng-lts/accordion';
import { AutoCompleteModule, } from 'primeng-lts/autocomplete';
import { BreadcrumbModule } from 'primeng-lts/breadcrumb';
import { ButtonModule } from 'primeng-lts/button';
import { CalendarModule } from 'primeng-lts/calendar';
import { CardModule } from 'primeng-lts/card';
import { CarouselModule } from 'primeng-lts/carousel';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { DataViewModule } from 'primeng-lts/dataview';
import { DropdownModule } from 'primeng-lts/dropdown';
import { FileUploadModule } from 'primeng-lts/fileupload';
import { InputTextModule } from 'primeng-lts/inputtext';
import { MessageModule } from 'primeng-lts/message';
import { MessagesModule } from 'primeng-lts/messages';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { PaginatorModule } from 'primeng-lts/paginator';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { ProgressSpinnerModule } from 'primeng-lts/progressspinner';
import { SelectButtonModule } from 'primeng-lts/selectbutton';
import { SharedModule } from 'primeng-lts/api';
import { SplitButtonModule } from 'primeng-lts/splitbutton';
import { TableModule } from 'primeng-lts/table';
import { TabViewModule } from 'primeng-lts/tabview';
import { TreeTableModule } from 'primeng-lts/treetable';

@NgModule({
    declarations: [],
    imports: [
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        CheckboxModule,
        DataViewModule,
        DropdownModule,
        FileUploadModule,
        InputTextModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        PaginatorModule,
        ProgressSpinnerModule,
        SelectButtonModule,
        SharedModule,
        SplitButtonModule,
        TableModule,
        ProgressBarModule,
        TabViewModule,
        TreeTableModule
    ],
    exports: [
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        CheckboxModule,
        DataViewModule,
        DropdownModule,
        FileUploadModule,
        InputTextModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        PaginatorModule,
        ProgressSpinnerModule,
        SelectButtonModule,
        SharedModule,
        SplitButtonModule,
        TableModule,
        ProgressBarModule,
        TabViewModule,
        TreeTableModule
    ],
})

export class PrimeNGModule { }